<template>
  <template v-for="route in routes" :key="route.name">
    <template v-if="!route.meta?.hidden">
      <template v-if="route.children?.length">
        <el-sub-menu
          :title="$t(route.meta?.title as string) || ''"
          :index="route.name"
          :icon="route.meta?.icon"
          style="--hep-text-color-secondary: #7a8699"
        >
          <MenuItem :routes="route.children" />
        </el-sub-menu>
      </template>
      <el-menu-item v-else :index="route.name" :icon="route.meta?.icon">
        {{ $t(route.meta?.title as string) }}
      </el-menu-item>
    </template>
  </template>
</template>

<script lang="ts" setup>
import type { RouteRecordRaw } from 'vue-router'
defineOptions({
  name: 'MenuItem',
})

withDefaults(
  defineProps<{
    routes: RouteRecordRaw[]
  }>(),
  {},
)
</script>

<style scoped lang="scss"></style>
